import type { MeScopes, Permission, Role } from "@kopi/contracts";
import type { PlainMessageKey } from "@/i18n/messages/id";

/** UI hint only: the API enforces permissions on every route. */
export function canTenantWide(scopes: MeScopes, permission: Permission): boolean {
  return scopes.grants.some((g) => g.permission === permission && g.outletId === null);
}

/** UI hint: allowed at this outlet (tenant-wide grants cover every outlet). */
export function canAt(scopes: MeScopes, permission: Permission, outletId: string): boolean {
  return scopes.grants.some(
    (g) => g.permission === permission && (g.outletId === null || g.outletId === outletId),
  );
}

/** UI hint: allowed at one or more outlets. */
export function canAnywhere(scopes: MeScopes, permission: Permission): boolean {
  return scopes.grants.some((g) => g.permission === permission);
}

export function hasRole(scopes: MeScopes, role: Role): boolean {
  return scopes.roles.some((r) => r.role === role);
}

export const ROLE_KEYS: Record<Role, PlainMessageKey> = {
  owner: "role.owner",
  outlet_manager: "role.outlet_manager",
  cashier: "role.cashier",
  barista: "role.barista",
  inventory_staff: "role.inventory_staff",
  finance: "role.finance",
};
